import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import periods from './modules/periods'
import ordermeal from './modules/ordermeal'
import records from './modules/records'
import errorLog from './modules/errorLog'
import getters from './getters'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    periods,
    ordermeal,
    records,
    errorLog
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js